const COMMENT_ITEMS = [
  {
    user: '吃瓜不嫌事大',
    avatar: '🍉',
    time: '10分钟前',
    content: '这个瓜我吃定了！细节越来越精彩了，坐等后续爆料。果然娱乐圈没有一天是太平的，91黑料yyds！',
    likes: '2.3k',
  },
  {
    user: '围观群众甲',
    avatar: '👀',
    time: '32分钟前',
    content: '作为老吃瓜人了，这次的料确实有分量。建议大家都来91黑料吃瓜在线围观，信息更新比别家快太多了。',
    likes: '1.8k',
  },
  {
    user: '八卦研究员',
    avatar: '🔍',
    time: '1小时前',
    content: '整理了一下时间线，一切早有端倪。黑料吃瓜爆料不停，这里的信息整合做得确实好，每天必刷。',
    likes: '1.2k',
  },
  {
    user: '理性吃瓜人',
    avatar: '🧐',
    time: '2小时前',
    content: '虽然很劲爆但还是要理性看待。建议等当事人正式回应后再下结论。不过91黑料吃瓜网的信息汇总确实全面。',
    likes: '980',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-950">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            <i className="ri-chat-smile-2-line text-primary-400 mr-2"></i>
            瓜友热议
          </h2>
          <p className="mt-2 text-sm text-foreground-500">围观群众的真实声音，吃瓜社区的精彩讨论</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {COMMENT_ITEMS.map((item, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-xl bg-background-800/30 border border-background-800/50 hover:border-primary-500/15 transition-all duration-200"
            >
              {/* Header */}
              <div className="flex items-center gap-3 mb-4">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-700/60 text-xl">
                  {item.avatar}
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-200">{item.user}</div>
                  <div className="text-xs text-foreground-600">{item.time}</div>
                </div>
              </div>

              {/* Content */}
              <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                {item.content}
              </p>

              {/* Footer */}
              <div className="flex items-center gap-4">
                <button className="flex items-center gap-1.5 text-xs text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer">
                  <i className="ri-thumb-up-line"></i>
                  {item.likes}
                </button>
                <button className="flex items-center gap-1.5 text-xs text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer">
                  <i className="ri-chat-1-line"></i>
                  回复
                </button>
                <button className="flex items-center gap-1.5 text-xs text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer">
                  <i className="ri-share-forward-line"></i>
                  分享
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}